// ============== КНОПКА "Back" ======================

// =====================================
// Селектори
// =====================================
const refs = {
  buttonBack: document.querySelector('[data-back]'),
  mapForm: document.getElementById('map-form'),
  carsSection: document.querySelector('.cars'),
};
const { buttonBack, mapForm, carsSection } = refs;

// =====================================
// Слухач кнопки "Back"
// =====================================
// Тихо виходимо, якщо елементів немає на сторінці
if (buttonBack && mapForm && carsSection) {
  // уникаємо подвійної ініціалізації
  if (!buttonBack.dataset.listenerAttached) {
    buttonBack.addEventListener('click', handlerClickButtonBack);
    buttonBack.dataset.listenerAttached = 'true';
  }
}

function handlerClickButtonBack() {
  if (mapForm) mapForm.style.display = 'block';
  if (carsSection) carsSection.style.display = 'none';

  if (mapForm?.scrollIntoView) {
    mapForm.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}
